<template>
  <ContextColorProvider context="wealth">
    <div class="portfolio">
      <HeroContainer>
        <template #navbar="{ isNavbarTransparent }">
          <NavBar :transparent="isNavbarTransparent">
            <template #left>
              <BackButton @click="handleGoBackClick" />
            </template>
            <template #right>
              <ShowMoneyToggleButton />
            </template>
          </NavBar>
        </template>
        <template #hero>
          <PortfolioHero />
        </template>
        <template #content>
          <main class="portfolio__main">
            <div class="portfolio__main__tabs-wrapper">
              <Tabs
                class="portfolio__main__tabs"
                data-testid="portfolio-tabs"
                :on-change="onChangeTab"
                :selected-index="currentTabIndex"
              >
                <TabList>
                  <Tab>Performance</Tab>
                  <Tab>Alocação</Tab>
                  <Tab>Ordens</Tab>
                  <Tab>Sobre</Tab>
                </TabList>
              </Tabs>
            </div>
            <div>
              <Performance
                v-if="currentTabIndex === IndexPortfolioTabsIndexes.Performance"
                :portfolio-id="portfolioId"
                :is-loading-portfolio="isLoading"
                :has-error-portfolio="hasError"
              />
              <Allocation
                v-if="currentTabIndex === IndexPortfolioTabsIndexes.Allocation"
                :portfolio-id="portfolioId"
              />
              <Orders
                v-if="currentTabIndex === IndexPortfolioTabsIndexes.Orders"
                :portfolio-id="portfolioId"
              />
              <About
                v-if="currentTabIndex === IndexPortfolioTabsIndexes.About"
                :portfolio-id="portfolioId"
              />
            </div>
          </main>
        </template>
      </HeroContainer>
    </div>
  </ContextColorProvider>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, provide, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import {
  NavBar,
  ContextColorProvider,
  Tabs,
  TabList,
  Tab
} from '@warrenbrasil/nebraska-web';
import { HeroContainer } from '@/modules/common/components/Hero';
import { BackButton } from '@/modules/common/components/buttons';
import { ShowMoneyToggleButton } from '@/modules/common/components/buttons/ShowMoneyToggleButton';
import {
  About,
  Allocation,
  Orders,
  Performance,
  PortfolioHero
} from './components';

import { IndexPortfolioTabsIndexes } from './types';
import { WarrenSession } from '@/modules/common/services/session';

const route = useRoute();
const router = useRouter();

const isLoading = ref(false);
const hasError = ref(false);
const currentTabIndex = ref(IndexPortfolioTabsIndexes.Performance);

const portfolioId = computed(() => {
  const { portfolioId } = route.params;

  return portfolioId;
});

provide('portfolioId', portfolioId);

const handleGoBackClick = () => {
  router.replace({ name: 'wealth' });
};

const onChangeTab = (selectedTabIndex: IndexPortfolioTabsIndexes) => {
  currentTabIndex.value = selectedTabIndex;
};

onMounted(async () => {
  const { tab } = route.query;
  if (tab === 'orders') {
    currentTabIndex.value = IndexPortfolioTabsIndexes.Orders;
  }
});

onUnmounted(() => {
  WarrenSession.remove('warren.indexPortfolio.filterOption');
});
</script>

<style lang="less" scoped>
.portfolio {
  &__header {
    max-width: 800px;
    margin: 0 auto;
  }

  &__main {
    padding-bottom: @size-spacing-x500;

    &__tabs-wrapper {
      position: relative;
      border-bottom: @size-border-x400 solid @divider-primary;
    }

    &__tabs {
      position: relative;
      top: @size-border-x400;
      max-width: calc(800px + 2 * @size-spacing-x400);
      width: 100%;
      margin: 0 auto;
      padding: 0 @size-spacing-x400;

      .from-md({
        max-width: calc(800px + 2 * @size-spacing-x800);
        padding: 0 @size-spacing-x800;
      });
    }
  }
}
</style>
